module.exports = __webpack_public_path__ + "static/media/news-press-v.d02d2ab9.jpg";